/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import FeaturesService from 'ember-feature-flags/services/features';

interface TooltipUnlessVerifiedSignature {
  Args: {
    condition: boolean;
    content: string;
    direction: string;
  };
  Element: HTMLSpanElement;
}

export default class TooltipUnlessVerified extends Component<TooltipUnlessVerifiedSignature> {
  @service account!: AccountService;
  @service features!: FeaturesService;

  get notVerified() {
    if (this.features.isEnabled('test_delivery_mode')) {
      return false;
    }
    return !this.account.verificationApproved;
  }
}
